import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from "antd";

import { actions } from "store";
import { SaunaForm, SaunaList } from "components/blocks/Sauna";
import { SitePageForm } from 'components/blocks/Site';


class SaunaListScreen extends Component {
  render() {
    const { site, history } = this.props;
    const detail = site.detail;

    return (
      <Fragment>
        <div className="page-content page-content-full">
          <div className="page-block page-block-full">
            {detail &&
            <SaunaList
              history={history}
              activeFilter={{ site: detail.id }}
              topActions={[
                <Button type="primary" className="" icon="plus" onClick={() => this.showForm()}>
                  Добавить анкету
                </Button>
              ]}
            />}
          </div>
        </div>

        {detail &&
        <SaunaForm siteId={detail.id}/>}

        {detail &&
        <SitePageForm siteId={detail.id}/>}
      </Fragment>
    );
  }
}


function mapStateToProps(state) {
  return {
    site: state.site,
    sauna: state.sauna,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.sauna), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SaunaListScreen);
